import {Component, Inject, OnInit} from '@angular/core';
import {DataService} from './data.service';
import {ActivatedRoute, Router} from '@angular/router';
import {DomSanitizer} from '@angular/platform-browser';
import {DOCUMENT} from '@angular/common';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'suppliesV2';
  mobile = false;
  sub;
  modelId;
  videoUrl1;
  videoUrl2;
  videoUrl3;
  videoUrl4;
  modelData;
  tabActive = 0;
  showSpecs = false;
  currentUrl;
  showVideo = false;
  closeResult = '';
  imgActive = null;
  oldId;

  constructor(
    private dataService: DataService,
    private route: ActivatedRoute,
    private router: Router,
    private sanitizer: DomSanitizer,
    private modalService: NgbModal,
    @Inject(DOCUMENT) private document: Document
  ) {

  }

  open(content) {
    this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'}).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {

    });
  }

  ngOnInit() {
    const referrer = document.referrer || null;
    this.mobile = window.innerHeight > 1000 ? false : true;
    var origen;
    if (location.href.indexOf('web') != -1) {
      origen = 'web';
    } else {
      origen = 'qr';
    }
    if (location.href.indexOf('#!') != -1) {
      this.oldId = (location.href).substring(location.href.indexOf('#!') + 3);
      /**
       * ANALYTICS
       */
      var origen;
      if (location.href.indexOf('web') != -1) {
        origen = 'web'
      } else {
        origen = 'qr';
      }
      if (this.oldId.indexOf('/') != -1) {
        this.oldId = this.oldId.substring(0, this.oldId.indexOf('/'));
      }
      /**
       * FIN ANALITICS
       */
      this.dataService.getModel(this.oldId, referrer)
        .subscribe((res: any) => {
          this.modelData = res;
          this.modelData.modelo = (this.modelData.modelo.indexOf('(') !== -1) ? this.modelData.modelo.substring(0, this.modelData.modelo.indexOf('(')) : this.modelData.modelo;
          if (this.modelData.video) {
            this.videoUrl1 = this.transform(this.modelData.video);
          }
          if (this.modelData.video2) {
            this.videoUrl2 = this.modelData.video2 && this.modelData.video2 !== '' ? this.transform(this.modelData.video2) : null;
          }
          if (this.modelData.allSpecs && this.modelData.allSpecs.length > 0) {
            this.showSpecs = true;
          }
          if (!this.modelData.headerMobileUrl) {
            this.modelData.headerMobileUrl = this.modelData.headerDesktopUrl;
          }
        });
    } else {

      this.sub = this.route
        .queryParams
        .subscribe(params => {
          // Defaults to 0 if no query param provided.
          this.modelId = params.modelId;
          this.currentUrl = window.location.href;
          if (this.modelId) {
            this.dataService.getModel(this.modelId, referrer)
              .subscribe((res: any) => {
                this.modelData = res;
                this.modelData.modelo = (this.modelData.modelo.indexOf('(') != -1) ? this.modelData.modelo.substring(0, this.modelData.modelo.indexOf('(')) : this.modelData.modelo;
                this.modelData.galeria = res.galeria.slice(0, 5);
                if (this.modelData.video) {
                  this.videoUrl1 = this.transform(this.modelData.video);
                }
                if (this.modelData.video2) {
                  this.videoUrl2 = this.modelData.video2 && this.modelData.video2 !== '' ? this.transform(this.modelData.video2) : null;
                }
                if (this.modelData.allSpecs && this.modelData.allSpecs.length > 0) {
                  this.showSpecs = true;
                }
                if (!this.modelData.headerMobileUrl) {
                  this.modelData.headerMobileUrl = this.modelData.headerDesktopUrl;
                }
              });
          }
        });
    }
  }
  sendEventDownloadPDF(){
  }

  setImgActive(index) {
    this.imgActive = index;
  }

  setTabActive(index) {
    this.tabActive = index;
  }

  transform(id) {
    const urlFinal = 'https://www.youtube-nocookie.com/embed/' + id;
    return this.sanitizer.bypassSecurityTrustResourceUrl(urlFinal);
  }

}

import {Pipe, PipeTransform, SecurityContext} from '@angular/core';
import {debuglog} from 'util';

@Pipe({
  name: 'sanitizeHtml'
})
export class SanitizeHtmlPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {
  }

  transform(value: any): any {
    return this.sanitizer.bypassSecurityTrustHtml(value);
  }
}
